import { Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Store } from "@ngrx/store";
import { AddDisclaimerAction } from "../disclaimers.actions";
import { MatDialogRef } from "@angular/material/dialog";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../../shared/error-state-matcher";

@Component({
  selector: "app-disclaimer-add",
  templateUrl: "./disclaimer-add.component.html",
  styleUrls: ["./disclaimer-add.component.scss"],
  standalone: false,
})
export class DisclaimerAddComponent implements OnInit {
  form: UntypedFormGroup;
  saving = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<DisclaimerAddComponent>,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl("", (c) => Validators.required(c)),
      htmlContent: new UntypedFormControl("", (c) => Validators.required(c)),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid) {
      return;
    }
    this.saving = true;
    const formValue = this.form.value as {
      name: string;
      htmlContent: string;
    };
    this.store.dispatch(new AddDisclaimerAction(formValue));
    this.dialogRef.close(true);
  };

  cancel = () => {
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
